import { render } from "./details2.vue?vue&type=template&id=78291193&scoped=true"
const script = {}

import "./details2.vue?vue&type=style&index=0&id=78291193&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78291193"]])

export default __exports__